/* eslint-disable react-hooks/exhaustive-deps */
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import { Container, Form, Spinner, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import ImportContactsTwoToneIcon from '@mui/icons-material/ImportContactsTwoTone';
import YesNoSwitch from 'components/input/YesNoSwitch';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ActivitiesConfig from './components/ActivitiesConfig';
import {
  BoolToString,
  checkEnableParseJSON,
  formatBoolean,
  reorder,
} from 'components/helper/helper';
import {
  getActivitiesAndHonors,
  updateActivitiesAndHonors,
} from 'app/activitiesAndHonors/activitiesAndHonorsSlice';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { debounce } from 'lodash';
import TextAreaInput from 'components/input/TextAreaInput';
import { identifyUserpilot } from 'utils/userpilotClient';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Grid from '@mui/joy/Grid';
import { ModalConfirm } from 'screen/common/ModalConfirm';
import { toggleReviewedAndComplete } from 'services/reviewAndComplete';
import { PAGE_NAME } from 'constants/common';
import pageStatusService from 'services/pageStatusService';
import { getAccessToken, removeAccessToken, removeUserId } from 'utils/sessionStorage';
import { getUserId } from 'utils/sessionStorage';

interface Props {}

interface ExpandMoreProps extends IconButtonProps {}

export const ExpandMore = styled((props: ExpandMoreProps) => {
  const { ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const Activities = (props: Props) => {
  const [activitiesData, setActivitiesData] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const activitiesAndHonors = useAppSelector((store:any) => store.activitiesAndHonors);
  const [expandAll, setExpandAll] = React.useState(false);
  const [expandActive, setExpandActive] = React.useState<number>(0);
  const query = new URLSearchParams(useLocation().search);
  const check = query.get('check');
  const indexExpand = query.get('index') || 0;
  let studentId = getUserId();
  let token = getAccessToken();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const information = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const role  = information?.user_role ?? '';

  const formik = useFormik({
    initialValues: {
      is_have_any_activity_to_report: '',
      activity_array: '',
      howHaveYouUsedYourEarnings: '',
    },
    onSubmit: async (values) => {
      studentId = getUserId();
      token = getAccessToken();
      if (token && studentId) {
        try {
          const activitiesDataMapped = activitiesData.map((item) => {
            return {
              ...item,
              howHaveYouUsedYourEarnings: values.howHaveYouUsedYourEarnings,
            };
          });
          const newValues = {
            ...values,
            student_id: studentId,
            is_have_any_activity_to_report: formatBoolean(values.is_have_any_activity_to_report),
            activity_array: JSON.stringify(activitiesDataMapped),
          };
          identifyUserpilot(studentId, role, {
            name: information?.first_name,
            email: information?.email,
            created_at: information?.created_at,
            activityTypes: activitiesDataMapped.map((item) => item.activityType).join(', '),
          });
          await dispatch(updateActivitiesAndHonors(newValues)).unwrap();
        } catch (ex) {
          console.log('Error: ', ex);
        }
      } else {
        handleLogout();
      }
    },
  });

  const handleExpandAll = () => {
    setExpandAll(!expandAll);
    if (!expandAll) {
      setExpandActive(activitiesData.length);
    } else {
      setExpandActive(0);
    }
  };

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    formik.handleSubmit();
    history.push(routers.honors.path);
  };

  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      try {
        setLoading(true);
        const pageStatus: {
          student_completed: boolean;
        } = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.ACTIVITIES);
        if(pageStatus) {
          setReviewedAndComplete(pageStatus.student_completed);
        }
        const res = await dispatch(getActivitiesAndHonors(studentId)).unwrap();
        const dataLoaded = res; //res.payload;
        if (dataLoaded) {
          const howHaveYouUsedYourEarnings =
            checkEnableParseJSON(dataLoaded.activity_array, [])?.[0]?.howHaveYouUsedYourEarnings ??
            '';
          formik.resetForm({
            values: {
              ...formik.values,
              ...dataLoaded,
              howHaveYouUsedYourEarnings,
              is_have_any_activity_to_report: BoolToString(
                dataLoaded.is_have_any_activity_to_report
              ),
            },
          });
          setActivitiesData(checkEnableParseJSON(dataLoaded.activity_array, []));
        }
        formik.setStatus('idle');
      } catch (ex) {
        console.log('Error: ', ex);
      }
      setLoading(false);
    } else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    getDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleAddActivities = () => {
    if (activitiesData.length > 29) return;
    setActivitiesData([...activitiesData, {}]);
  };

  const handleExpandActive = (value: any) => {
    value
      ? setExpandActive(Math.abs(expandActive - 1))
      : setExpandActive(Math.abs(expandActive + 1));
  };

  useEffect(() => {
    if (expandActive === activitiesData.length) {
      setExpandAll(true);
    }

    if (expandActive === 0) {
      setExpandAll(false);
    }
  }, [expandActive, activitiesData.length]);

  // Drag and drop
  const [forceRenderKey, setForceRenderKey] = React.useState(0);
  const onDragEnd = async (result: any) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }
    const dataList = reorder(activitiesData, result.source.index, result.destination.index);
    setActivitiesData([...dataList]);
    setForceRenderKey(forceRenderKey + 1);
  };

  // BEGIN - Auto save function ==========
  React.useEffect(() => {
    if (!!formik.status) debounceSaving();
  }, [formik.values, activitiesData]);

  const debounceSaving = React.useCallback(
    debounce(() => {
      if (!loading) formik.handleSubmit();
    }, 1500),
    []
  );
  // END - Auto save function ==========

  let showEarning = activitiesData.filter((i) => i?.categoryUC === 'Work Experience')?.length > 0;
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [removeIndex, setRemoveIndex] = React.useState<number | null>(null);
  const handleClose = () => {
    setOpenConfirm(false);
    setRemoveIndex(null);
  };
  const handleConfirm = (index: number) => {
    const newActivitiesData = [...activitiesData];
    newActivitiesData.splice(index, 1);
    setActivitiesData(newActivitiesData);
    setOpenConfirm(false);
    setRemoveIndex(null);
  };
  const handleRemoveActivity = (index: number) => {
    setRemoveIndex(index);
    setOpenConfirm(true);
  };
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => {
    void toggleReviewedAndComplete(PAGE_NAME.ACTIVITIES, reviewedAndComplete, setReviewedAndComplete);
  }
  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { percentOnProcess: 30, title: 'Activities', specialId: 'Activities' },
          { percentOnProcess: 60, title: 'Activity Details', specialId: 'Activity_Details' },
          { percentOnProcess: 90, title: 'Selected Apps', specialId: 'Selected_Apps' },
        ]}
        title="Activities"
        process={1}
        icon={<ImportContactsTwoToneIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '120px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <div id="Activities" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                Activities
              </span>
            </div>
            <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
              <Grid xs={12}>
                <div className="mb-2" style={{ fontSize: '1rem' }}>
                  Reporting activities can help colleges better understand your life outside of the
                  classroom. Examples of activities might include: Arts or music, Clubs, Community
                  engagement, Family responsibilities, Hobbies Sports, Work or volunteering, Other
                  experiences that have been meaningful to you.
                </div>
              </Grid>
              <Grid xs={12}>
                <div style={{ fontSize: '1rem' }}>
                  Please list your activities in the order of their importance to you.
                </div>
              </Grid>
              <Grid xs={12}>
                <div className="bg-light rounded p-2 mb-4" style={{ fontSize: '1rem' }}>
                  <div>App Notes:</div>
                  <div> Common Application allows for up to 10 Activities + 5 Honors or Awards</div>
                  <div> UC Application allows for a total of 20 Activites, Honors or Awards</div>
                </div>
              </Grid>
              <Grid xs={12}>
                <YesNoSwitch
                  label="Do you have any activities that you wish to report? *"
                  className="common-flag"
                  name="is_have_any_activity_to_report"
                  dataUp="act-have-activities"
                  values={formik.values.is_have_any_activity_to_report}
                  onChange={(e: any) => {
                    formik.handleChange(e);
                  }}
                  disabled={reviewedAndComplete}
                />
              </Grid>
              {expandActive===0 && (
                <div id="Activity_Details"></div>
              )}
              <Grid xs={12}>
                <DragDropContext onDragEnd={onDragEnd} key={forceRenderKey}>
                  {activitiesData.length > 0 && (
                    <div className="d-flex justify-content-end">
                      <ExpandMore
                        aria-expanded={expandAll}
                        aria-label="show all"
                        onClick={handleExpandAll}
                      >
                        {!expandAll ? (
                          <KeyboardDoubleArrowDownIcon />
                        ) : (
                          <KeyboardDoubleArrowUpIcon />
                        )}
                      </ExpandMore>
                    </div>
                  )}
                  <Droppable droppableId="list">
                    {(provided) => (
                      <div className='w-100 bg-white py-2 box-collapse rounded-3' ref={provided.innerRef} {...provided.droppableProps}>
                        {activitiesData.map((item, index) => (
                          <div key={index + '-' + activitiesData.length}>
                            <Draggable
                              draggableId={index + '-' + activitiesData.length}
                              index={index}
                              isDragDisabled={isMobile}
                            >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...(!isMobile ? provided.dragHandleProps : {})}
                                >
                                  <div className="position-relative">
                                    <ActivitiesConfig
                                      disabled={reviewedAndComplete}
                                      handleSave={(values) => {
                                        const newActivitiesData = [...activitiesData];
                                        newActivitiesData.splice(index, 1, values);
                                        setActivitiesData(newActivitiesData);
                                      }}
                                      item={item}
                                      indexNumber={`${index + 1}/${activitiesData.length}`}
                                      expandAll={expandAll}
                                      handleExpandActive={handleExpandActive}
                                      check={check}
                                      indexExpand={`${indexExpand}/${activitiesData.length}`}
                                      isMobile={isMobile}
                                    />
                                    <RemoveCircleOutlineIcon
                                      className="position-absolute text-field-light pointer"
                                      style={{ 
                                        right: isMobile ? '-12px' : '-24px', 
                                        top: isMobile ? '8px' : '12px',
                                        fontSize: isMobile ? '20px' : '24px'
                                      }}
                                      onClick={() => {
                                        if (reviewedAndComplete) return;
                                        handleRemoveActivity(index);
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          </div>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </Grid>
              <Grid xs={12}>
                <div className="my-3 w-100 d-flex flex-column align-items-center">
                  <div className="text-field-light sized70">You can add up to 30 activities</div>
                  <Button variant="primary" className="p-2 px-5" onClick={handleAddActivities} disabled={reviewedAndComplete}>
                    Add another Activity/Experience
                  </Button>
                </div>
              </Grid>
              <Grid xs={12} className={!showEarning ? 'd-none' : ''}>
                <div>
                  Please tell us how you've used your earnings from all of the jobs you've listed.
                  This information will NOT be used to determine financial aid — rather, it gives us
                  more context about you and your experiences.
                </div>
              </Grid>
              <Grid xs={12}>
                <TextAreaInput
                  hidden={!showEarning}
                  logo="span-uc-logo"
                  mdCol="12"
                  countText={250}
                  label="How have you used or will you use your earnings?"
                  dataUp="act-earnings"
                  name="howHaveYouUsedYourEarnings"
                  values={formik.values.howHaveYouUsedYourEarnings}
                  onChange={(e: any) => {
                    formik.handleChange(e);
                  }}
                  isCMLogo={true}
                  disabled={reviewedAndComplete}
                />
              </Grid>
            </Grid>
            <div className={`${isMobile ? 'my-2' : 'my-3'} d-flex ${isMobile ? 'flex-column' : 'justify-content-between'} border-top ${isMobile ? 'pt-2' : 'pt-3'}`}>
              <div className={`${isMobile ? 'w-100 mb-3' : ''} d-flex justify-content-start`}>
                <div className="d-flex flex-column align-items-start">
                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed
                    </span>
                  </div>
                </div>
              </div>
              
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {activitiesAndHonors.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>
      <ModalConfirm 
        open={openConfirm}
        handleClose={handleClose} 
        handleConfirm={() => {
          if (removeIndex !== null) handleConfirm(removeIndex);
        }}
        title=""
        message="Are you sure you want to remove this activity?"
        confirmText="Remove"
        cancelText="Cancel"
      />
    </>
  );
};

export default Activities;
